<template>
  <div class=" pwc-detail-info">
    <v-layout v-if="(!event.detail.detailImgUrls||event.detail.detailImgUrls.length <= 0||event.detail.detailImgUrls[0]==='')&&event.detail.eventDescription&&event.detail.eventDescription.trim()!==''" row wrap>
      <v-card flat class="pwc-info-card">
        <v-card-title
          class="pwc-content-title"
        >
          <span>活动内容</span>
        </v-card-title>
        <v-card-text class="pwc-content-description" />
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="pwc-content-text" v-html="cDescription" />
      </v-card>
    </v-layout>

    <v-layout v-if="(!event.detail.detailImgUrls||event.detail.detailImgUrls.length <= 0||event.detail.detailImgUrls[0]==='')&&event.detail.speakers && event.detail.speakers.length>0" row wrap>
      <v-card flat class="pwc-info-card">
        <v-card-title class="pwc-content-title">
          <span>与会嘉宾</span>
        </v-card-title>
        <div class="pwc-event-speakers">
          <event-speaker v-for="p in event.detail.speakers" :key="p.name" :profile="p" />
        </div>
      </v-card>
    </v-layout>

    <v-layout v-if="event.detail.detailImgUrls && event.detail.detailImgUrls.length >0" row wrap>
      <v-card flat class="pwc-info-card">
        <v-card-title class="pwc-content-title">
          <!-- <span>活动海报</span> -->
        </v-card-title>
        <v-card-title class="pwc-event-poster">
          <v-img
            v-for="u in event.detail.detailImgUrls"
            :key="u"
            width="100%"
            :src="u"
          />
        </v-card-title>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import EventSpeaker from '../EventSpeaker'

export default {
  inject: ['event'],
  components: {
    EventSpeaker
  },
  data() {
    return {
      evt: this.event
    }
  },
  computed: {
    cDescription() {
      const arr = (this.event.detail.eventDescription || '').split('\n')
      return arr.join('<br>').trim()
    }
  }
}

</script>

<style lang="scss" scoped>
.pwc-detail-info {
      margin:auto;
      max-width: 960px;
      box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.08);
      // border-radius: 8px;
      border: solid 1px #eee;
      margin-top: 30px;
      padding-bottom: 40px;
      .pwc-info-card {
        width: 100%;
        .pwc-content-title {
            span {
              display: block;
              margin: auto;
              background-color: #ffbf1f;
              height: 38px;
              line-height: 34px;
              padding: 1px 18px;
              color: #2d2d2d;
              font-size: 18px;
              font-weight: bold;
            }
        }
        .pwc-event-speakers {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
        }
        .pwc-content-description {
          padding-left: 64px;
          padding-right: 64px;
          font-family: "Helvetica Neue",Helvetica,"Hiragino Sans GB","Microsoft YaHei",Arial,sans-serif;
          font-size: 16px;
        }
        .pwc-content-text{
          padding-left: 10%;
          padding-right: 10%;
        }
        @media all and (max-width: 960px)  {
          .pwc-content-description {
            padding-left: 16px;
            padding-right: 16px;
          }
        }

    }
}
</style>

